import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-left">
          <span className="footer-logo">◈ ARIA</span>
          <span className="footer-copy">Autonomous Resolution Intelligence Architecture</span>
        </div>
        <div className="footer-links">
          <a href="https://github.com/ARIA-AutonomousResolution-Intelligence" target="_blank" rel="noopener noreferrer">GitHub</a>
          <span className="footer-sep">·</span>
          <span className="footer-copy">Built with intelligent agents</span>
        </div>
      </div>
    </footer>
  );
}
